import { DownloadMaterialsTabController } from './download-materials-tab.controller'

function downloadMaterialsTab () {
  return {
    restrict: 'E',
    templateUrl: '/arts/directives/download-materials-tab/download-materials-tab-directive.html?$$REVISION$$',
    controller: DownloadMaterialsTabController
  }
}

export { downloadMaterialsTab }
